export function getTimeStamp() {
  return new Date().getTime();
}
